import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'excerpt', label: 'Excerpt', type: 'textarea', rows: 2 },
    { key: 'body', label: 'Body', type: 'rich-text' },
    { key: 'category', label: 'Category', type: 'text' },
    { key: 'date', label: 'Date', type: 'text', placeholder: 'YYYY-MM-DD' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'image_url', label: 'Cover image', type: 'upload-image', prefix: 'news' },
    { key: 'is_event', label: 'Is Event?', type: 'checkbox', checkboxLabel: 'This is an upcoming event' },
    { key: 'event_datetime', label: 'Event date-time', type: 'text', placeholder: 'YYYY-MM-DD HH:MM' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'category', label: 'Category' },
    { key: 'date', label: 'Date' },
    {
        key: 'is_event',
        label: 'Type',
        render: (r) => (r.is_event ? 'Event' : 'News'),
    },
];

const defaultItem = {
    title: '',
    excerpt: '',
    body: '',
    category: 'News',
    date: '',
    location: '',
    image_url: '',
    is_event: false,
    event_datetime: '',
    order: 99,
};

export default function AdminNewsPage() {
    return (
        <CrudManager
            resource="news"
            title="News & Events"
            description="Announcements, upcoming events and recent milestones."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category']}
        />
    );
}
